import { render, staticRenderFns } from "./LogisticsCompany.vue?vue&type=template&id=fc54483e&scoped=true"
import script from "./LogisticsCompany.vue?vue&type=script&lang=js"
export * from "./LogisticsCompany.vue?vue&type=script&lang=js"
import style0 from "./LogisticsCompany.vue?vue&type=style&index=0&id=fc54483e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc54483e",
  null
  
)

export default component.exports